import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../query-client';
import { IPagination } from '../IPagination';
import {
    IFetchEventAnalyticGroupedByBatchIdRequestParams,
    IEventAnalyticGroupedByBatchId,
    IFetchEventAnalyticGroupedBySiteRequestParams,
    IEventAnalyticGroupedBySite,
    IEventAnalyticEnergyUsageParams,
    IFetchEarliestEventInBatchParams,
} from './interface';
import { fetchEventAnalyticGroupedByBatch, fetchEventAnalyticGroupedBySite, getEnergyUsageDuringEvent, getEarliestEventInBatch } from './index';
import { EnergyUsageTimeseriesDto } from '../energy/interface';
import { IEvent } from '../event/interface';

export const useEventAnalyticGroupedByBatchIdListQuery = (query: IFetchEventAnalyticGroupedByBatchIdRequestParams, options = {}) => {
    return useQuery<IPagination<IEventAnalyticGroupedByBatchId>, Error>({
        queryKey: [QueryKey.EVENT_ANALYTIC_BATCH, query],
        queryFn: () => fetchEventAnalyticGroupedByBatch(query),
        ...options,
    });
};

export const useEventAnalyticGroupedBySiteListQuery = (query: IFetchEventAnalyticGroupedBySiteRequestParams, options = {}) => {
    return useQuery<IPagination<IEventAnalyticGroupedBySite>, Error>({
        queryKey: [QueryKey.EVENT_ANALYTIC_SITE, query],
        queryFn: () => fetchEventAnalyticGroupedBySite(query),
        ...options,
    });
};

export const useEnergyUsageDuringEventQuery = (query: IEventAnalyticEnergyUsageParams, options = {}) => {
    return useQuery<EnergyUsageTimeseriesDto[], Error>({
        queryKey: [QueryKey.EVENT_ANALYTIC_ENERGY_USAGE, query],
        queryFn: () => getEnergyUsageDuringEvent(query),
        ...options,
    });
};

export const useEarliestEventInBatchQuery = (query: IFetchEarliestEventInBatchParams, options = {}) => {
    return useQuery<IEvent, Error>({
        queryKey: [QueryKey.EVENT_ANALYTIC_EARLIEST_EVENT, query],
        queryFn: () => getEarliestEventInBatch(query),
        ...options,
    });
};
